export default __webpack_public_path__ + "static/media/Fruits_slides.b7aecee6.jpg";